"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MY_PLACE_DEFAULT_BODY = exports.MY_PLACE_DEFAULT_HEADING = exports.MY_PLACE_PEEKS_DISTINCT_USERS_MIN = exports.MY_PLACE_PEEKS_24H_MIN = exports.MY_PLACE_LIVE_CHECKINS_BASELINE_MULTIPLIER = exports.MY_PLACE_LIVE_CHECKINS_MIN = exports.MY_PLACE_IGNORE_COOLDOWN_DAYS = exports.MY_PLACE_IGNORE_STREAK = exports.MY_PLACE_PUSH_MAX_PER_VENUE_24H = exports.MY_PLACE_PUSH_MAX_PER_USER_24H = exports.MY_PLACE_PUSH_MAX_PER_USER_6H = exports.MY_PLACE_PINNED_LIMIT = void 0;
exports.MY_PLACE_PINNED_LIMIT = 20;
exports.MY_PLACE_PUSH_MAX_PER_USER_6H = 1;
exports.MY_PLACE_PUSH_MAX_PER_USER_24H = 3;
exports.MY_PLACE_PUSH_MAX_PER_VENUE_24H = 1;
exports.MY_PLACE_IGNORE_STREAK = 3;
exports.MY_PLACE_IGNORE_COOLDOWN_DAYS = 7;
exports.MY_PLACE_LIVE_CHECKINS_MIN = 3;
exports.MY_PLACE_LIVE_CHECKINS_BASELINE_MULTIPLIER = 2;
exports.MY_PLACE_PEEKS_24H_MIN = 10;
exports.MY_PLACE_PEEKS_DISTINCT_USERS_MIN = 5;
exports.MY_PLACE_DEFAULT_HEADING = '{{venue}}';
exports.MY_PLACE_DEFAULT_BODY = 'Other people are interested in {{venue}}. Tap for details.';
//# sourceMappingURL=my-places.js.map